/* eslint-disable react/require-default-props */
import React from 'react';
import { colors } from '@/styles';

export type LargePlayProps = {
  title?: string;
  backgroundFill?: string;
  foregroundFill?: string;
  className?: string;
  transparentBackground?: boolean;
};

/**
 * A play button, but larger
 */
export function LargePlay({
  title = 'Play',
  backgroundFill = colors.white,
  foregroundFill = colors.taosSky,
  className = '',
  transparentBackground = false,
}: LargePlayProps) {
  return (
    <svg
      className={`${className} ${transparentBackground ? 'transparent' : ''}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 84 84"
    >
      {Boolean(title) && <title>{title}</title>}
      <circle className="outer" fill="none" cx="42" cy="42" r="35" />
      <circle
        className="play-background"
        fill={backgroundFill}
        cx="42"
        cy="42"
        r="35"
        opacity={transparentBackground ? 0.78 : 1}
      />
      <path
        className="play-foreground"
        fill={foregroundFill}
        d="M35.43,53.71,53.25,42.57a.67.67,0,0,0,.21-.9h0a.7.7,0,0,0-.2-.22L35.44,30.3a.68.68,0,0,0-.9.2h0a.77.77,0,0,0-.09.36V53.13a.64.64,0,0,0,.62.66h0A.57.57,0,0,0,35.43,53.71Z"
        transform="translate(0)"
      />
    </svg>
  );
}
